import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { useState } from "react";
import { message } from "antd";
import { deleteVoice } from "./service";
import { showErrorToast } from "V2.0/utils";

function VoiceDelete(props) {
  const { item, open, onClose, fetchVoices } = props;
  const [loading, setLoading] = useState(false);

  async function handleDelete() {
    message.loading("Deleting Voice");
    setLoading(true);
    try {
      const response = await deleteVoice({
        voiceId: item._id,
      });
      if (response.status === 200) {
        setLoading(false);
        fetchVoices();
        message.destroy();
        message.success("Voice deleted");
        onClose();
      }
    } catch (e) {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Failed to delete voice");
    }
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Voice?</DialogTitle>
      <DialogActions>
        <Button outline onClick={onClose}>
          Cancel
        </Button>
        <Button loading={loading} onClick={handleDelete}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { VoiceDelete };
